import { connect } from "react-redux";
import ToolkitInspection from './toolkitInspection';
import { bindActionCreators } from "redux";
import {fetchMaterialInspection} from 'services/redux/ToolkitInspection/action'
import {materialInspected} from 'services/redux/ToolkitInspection/action'

const mapStateToProps = (state) => ({
    fetchMaterialInspetionList: state.toolkitInspection.fetchMaterialInspetionList
})

const mapDispatchToProps = (dispatch) => 
    bindActionCreators({
        fetchMaterialInspection,
        materialInspected
    }, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(ToolkitInspection);